import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page95() {
  useEffect(() => {
    document.title = "Маяк — Страница 94"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page93" />
        <ForwardLink href="/page95" />
      </div>

      <p style={{ textAlign: "right" }}>94.</p>
      <p>Длинная пауза.</p>
      <p><i>Он мертв?</i></p>
      <p>Неожиданно МОЛОДОЙ паникует...</p>
      <p>Он прыгает в могилу и начинает руками выкапывать СТАРИКА...</p>
      <p>Копает и копает и вычерпывает...</p>
      <p>Он поднимает СТАРИКА. Держит его.</p>
      <p>Пауза. МОЛОДОЙ переводит дыхание.</p>
      <p>МОЛОДОЙ берет МЕДНЫЕ КЛЮЧИ с жилетки СТАРИКА...</p>
      <p>Он позволяет СТАРИКУ упасть в ил как камень.</p>
      <p>МОЛОДОЙ уходит.</p>
      <p>
        МОЛОДОЙ этого не видит, но позади него в кадр влетают несколько<br/>
        ЧАЕК.
      </p>
      <br/>
      <p>ВНУТРИ. МАЯК. КОТЕЛЬНАЯ – ПОЛДЕНЬ</p>
      <p>МОЛОДОЙ медленно приближается к длинной лестнице.</p>
      <p>Он смотрит вверх...</p>
      <p>Кладет руки на перила...</p>
      <p>Он наконец готов войти в фонарное отделение.</p>
      <p>Но что-то останавливает его...</p>
      <p>Нет, он не может продолжать.</p>
      <p>Он похлопывает себя по нагрудному карману... нет сигарет.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>МОЛОДОЙ проходит через камбуз. Подходит к столу...</p>
      <p>ВОТ ОН: ЕГО МЕШОЧЕК С ТАБАКОМ.</p>
      <p>Он начинает скручивать сигарету...</p>
      <p>Смотрит вниз:</p>
      <p>
        На него смотрит ДЫРА В СЕРЕДИНЕ СТОЛА -- НО<br/>
        ТОПОРА НЕТ...
      </p>
      <p style={{ textAlign: "right" }}>94.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page93" />
        <ForwardLink href="/page95" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710718934/the-lighthouse-script/w93e68k0vz3sjeougve1.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page95;
